import { Fragment, useMemo } from 'react'

import Loading from '@/components/loading'

import { useStyles } from './styles'

interface DefaultProps {
  variant?: 'default'
  length?: never
  maxSizeBox?: never
}

interface BoxProps {
  variant: 'box'
  length?: number
  maxSizeBox?: number | string
}

type ShimmerProps = BoxProps | DefaultProps

export const Shimmer = ({
  variant = 'default',
  length = 1,
  maxSizeBox = '14rem',
}: ShimmerProps) => {
  const classes = useStyles()

  const variants = {
    default: useMemo(
      () => (
        <div className={classes.defaultLoadingContainer}>
          <Loading size={'3rem'} color='inherit' />
        </div>
      ),
      [],
    ),
    box: useMemo(
      () => (
        <>
          {Array.from({ length }).map((_, index) => (
            <Fragment key={index}>
              <div
                data-testid='loading-container'
                className={classes.boxLoadingContainer}
                style={{ maxHeight: maxSizeBox }}
              >
                <Loading size={'3rem'} color='inherit' />
              </div>
            </Fragment>
          ))}
        </>
      ),
      [length, maxSizeBox],
    ),
  }

  return variants[variant]
}
